module.exports = __webpack_public_path__ + "img/lightbluearw.f793f8a6.svg";